export default __webpack_public_path__ + "static/media/sequelize.bf020b1c.png";